<template> 
  <stats-card data-background-color="green" :key="componentKey">
    <template slot="header">
      <strong>{{title}}</strong>
    </template>

    <template slot="content">
      <p class="category">{{dataList[0]}}/{{dataList[1]}} {{dimension}}</p>
      <mdb-pie-chart
        datalabels
        :data="pieChartData"
        :options="pieChartOptions"
      />
    </template>

    <template slot="footer">
      <div class="stats">
        <md-icon>date_range</md-icon>
        Last updated at: {{updated_at}}
      </div>
    </template>
  </stats-card>

</template>

<script>
  import { mdbPieChart, mdbContainer } from "mdbvue";
  import { StatsCard } from "@/components";

  export default {
    name: 'PieHTTPP2P',
    props: ['title', 'updated_at', 'dataList', 'labels', 'dimension'],
    components: {
      StatsCard,
      mdbPieChart,
      mdbContainer
    },
    data() {
      return {
        componentKey: 0,
        pieChartData: {
          deep: true,
          labels: this.labels,
          datasets: [
            {
              data: this.dataList,
              backgroundColor: [
                "#F7464A",
                "#46BFBD"
              ],
              hoverBackgroundColor: [
                "#FF5A5E",
                "#5AD3D1"
              ]
            }
          ]
        },
        pieChartOptions: {
          responsive: false,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              color: "white",
              align: "center",
              font: {
                size: 16
              },
              formatter: value => {
                const [dataset] = this.pieChartData.datasets;
                const setValue = dataset.data.reduce((a, b) => a + b);
                return `${Math.round((value / setValue) * 100)}%`;
              }
            }
          }
        }
      };
    },
    watch: {
      updated_at: function() {
        this.pieChartData.datasets[0].data = this.dataList;
        this.componentKey += 1;
      }
    }
  };
</script>
